import { css } from '@emotion/react';

export const useStyles = (props) => ({
  editDeviceLimitDialogContainer: css({
    width: 360,
    paddingTop: 16,
  }),
  editDeviceLimitDialogActions: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginTop: 45,
  }),
  editDeviceLimitTypography: css({
    marginBottom: 13,
  }),
  editDeviceLimitTypographyClient: css({
    marginBottom: 50,
  }),
});
